var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ServerSideResult',{staticStyle:{"width":"100%"},attrs:{"test":_vm.agents}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"dense":"","headers":_vm.headers,"items":_vm.agents,"item-key":"id"},on:{"click:row":_vm.selectAgent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }